'use client';
import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { Grid, GridItem, Box, Text } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBallotCheck,
  faLayerGroup,
  faToolbox,
  faCalendarDays,
  faCartShopping,
  faClipboardListCheck,
} from '@fortawesome/pro-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { setStateValue } from '@/app/redux/slices/configGymSlice';

export default function ProgressNav() {
  const router = useRouter();
  const dispatch = useDispatch();
  const service = useSelector((state) => state.gym.serviceOpt);
  const progress = useSelector((state) => state.gym.progressOpt);
  const survey = useSelector((state) => state.gym.survey);
  const isCheckoutValid = useSelector((state) => state.gym.isCheckoutValid);
  const isNextValid = useSelector((state) => state.gym.isNextValid);
  const isMobile = useSelector((state) => state.gym.isMobile);
  // State for derived values
  const [surveyCompleted, setSurveyCompleted] = useState(false);

  // Update `surveyCompleted` dynamically
  useEffect(() => {
    setSurveyCompleted(survey.some((item) => item.complete));
  }, [survey]);
  useEffect(() => {
    console.log(`Progress changed to: ${progress}`);
    // Additional logic for handling progress changes (e.g., fetching data)
  }, [progress]);

  // Columns for navigation
  const columns = [
    { name: 'Service', icon: faBallotCheck },
    { name: 'Mirrors', icon: faLayerGroup },
    // { name: 'Fitting', icon: faToolbox },
    // { name: 'Survey', icon: faClipboardListCheck },
    { name: 'Survey', icon: faCalendarDays },
    { name: 'Payment', icon: faCartShopping },
  ];
  // Filter logic for visibility
  const filteredColumns = columns.filter((column) => {
    if (service === 'booking' && column.name === 'Mirrors') {
      return false;
    }
    // Show 'Survey' only when progress is 'Booking'
    if (service !== 'booking' && column.name === 'Survey') {
      return false;
    }
    return true;
  });
  useEffect(() => {}, [progress]);

  // Style objects
  const progressChoice = {
    color: '#00000050',
    fontWeight: '300',
    borderBottom: '3px solid #00000020',
    _hover: {
      fontWeight: '700',
      color: '#0cc6de',
      borderBottom: '3px solid #0cc6de',
      cursor: 'pointer',
    },
  };
  const progressSelected = {
    color: '#000000',
    fontWeight: '700',
    borderBottom: '3px solid #000000',
  };

  // Handle selection
  const handleSelect = (name) => {
    console.log('isCheckoutValid ', isCheckoutValid);
    console.log('surveyCompleted ', surveyCompleted);
    console.log('name ', name);
    dispatch(setStateValue({ key: 'progressOpt', value: name }));
    if (isMobile) {
      router.push('/mobile');
    }
  };

  return (
    <Grid
      templateColumns={`repeat(${filteredColumns.length}, 1fr)`}
      gap={0}
      p={0}
      width="100%"
      padding={{ base: '4vw 4vw 10vw 4vw', md: '1.5vw 1.5vw 0 1.5vw' }}
    >
      {filteredColumns.map((column, index) => {
        // Define the disabled state for each column
        const isDisabled = column.name === 'Payment' && !isNextValid;

        return (
          <GridItem
            key={index}
            fontSize={{ base: '4vw', md: '1vw' }}
            height="3vw"
          >
            <Box
              {...(progress === column.name
                ? progressSelected
                : progressChoice)}
              display="flex"
              alignItems="center"
              justifyContent="center"
              padding="0 0 0.5vw 1vw"
              height={{ base: '8vw', md: '2vw' }}
              onClick={!isDisabled ? () => handleSelect(column.name) : null} // Disable onClick
              cursor={!isDisabled ? 'pointer' : 'not-allowed'} // Change cursor style
              opacity={!isDisabled ? 1 : 0.5} // Reduce opacity when disabled
            >
              <Box>
                <FontAwesomeIcon
                  icon={column.icon}
                  style={{
                    marginRight: progress === column.name ? '1.2vw' : '0',
                  }}
                />
              </Box>
              {(!isMobile || progress === column.name) && (
                <Text ml="1vw" transition="opacity 0.3s ease-in-out">
                  {column.name}
                </Text>
              )}
            </Box>
          </GridItem>
        );
      })}
    </Grid>
  );
}
